module.exports = __webpack_public_path__ + "img/regular-desc@2x.85bf8cc4.png";